module.exports = __webpack_public_path__ + "img/cover-marc.ce07f7f9.png";